import { useEffect, useContext } from 'react';
import userContext from '../../context/users/UserContext';
import themeContext from '../../context/theme/ThemeContext';
import CustomBreadCrumb from '../../components/CustomBreadCrumb';
import { breadCrumbItems } from './Helper';
import AIRequestList from './AIRequestList';

const AIRequests = () => {
  const { roles, username, loadByUsername, authenticated } =
    useContext(userContext);
  const { getThemeColor } = useContext(themeContext);

  useEffect(() => {
    if (!authenticated) {
      console.log('--- Authentication again ----');
      loadByUsername();
      return;
    }
  }, [authenticated]);

  // useEffect(() => {
  //   if (
  //     document.getElementById(SELECTED_TAB_KEY.PACSQUEUE + '1') != null
  //   ) {
  //     document.getElementById(
  //       SELECTED_TAB_KEY.PACSQUEUE + '1'
  //     ).style.border = getThemeColor('border');
  //     document.getElementById(
  //       SELECTED_TAB_KEY.PACSQUEUE + '1'
  //     ).style.borderBottom = 'unset';
  //     document.getElementById(
  //       SELECTED_TAB_KEY.PACSQUEUE + '1'
  //     ).style.borderRadius = '10px 10px 0px 0px';
  //   }
  // }, [document.getElementById(SELECTED_TAB_KEY.PACSQUEUE + '1')]);

  return (
    <>
      {roles?.length > 0 && (
        <div className="main-container-body">
          <div className="breadCrumb">
            <CustomBreadCrumb items={breadCrumbItems} />
          </div> 
          <div
            style={{
              //padding: '0px 3px',
              //marginTop: '10px',
              boxSizing: 'border-box',
              height: 'calc(100% - 59px)',
            }}
          >
            {/* <div
              style={{
                borderBottom: getThemeColor('border'),
                width: '100%',
                boxSizing: 'border-box',
              }}
            ></div> */}
            {<AIRequestList />}
          </div>
        </div>
      )}
    </>
  );
};

export default AIRequests;